var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FormArray } from '@angular/forms';
import { DwDataRow } from './data-row';
var DwDataTable = /** @class */ (function (_super) {
    __extends(DwDataTable, _super);
    function DwDataTable(datasource) {
        var _this = this;
        var controls = DwDataTable.parseToControl(datasource);
        _this = _super.call(this, controls) || this;
        return _this;
    }
    Object.defineProperty(DwDataTable.prototype, "rows", {
        get: function () {
            return this.controls;
        },
        enumerable: true,
        configurable: true
    });
    DwDataTable.prototype.insertRow = function (index, data) {
        var control = new DwDataRow(data);
        control.markAsCreate();
        this.insert(index, control);
    };
    DwDataTable.prototype.pushRow = function (data) {
        var control = new DwDataRow(data);
        control.markAsCreate();
        this.push(control);
    };
    DwDataTable.prototype.updateRow = function (index, data) {
        var control = new DwDataRow(data);
        this.controls[index] = control;
        control.markAsUpdate();
    };
    DwDataTable.prototype.deleteRow = function (index) {
        if (this.controls[index]) {
            this.controls[index].markAsDelete();
        }
    };
    DwDataTable.parseToControl = function (data) {
        var controls = [];
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var rowdata = data_1[_i];
            var row = new DwDataRow(rowdata);
            controls.push(row);
        }
        return controls;
    };
    return DwDataTable;
}(FormArray));
export { DwDataTable };
